module.exports = __webpack_public_path__ + "static/img/parking.30404048.svg";